import React from 'react';
import AppLayout from '../components/app/AppLayout';
import CommunityPlaceholder from '../components/app/CommunityPlaceholder';

function CommunityPage() {
  return (
    <AppLayout>
      <CommunityPlaceholder />
    </AppLayout>
  );
}

export default CommunityPage;








